import { useCallback } from "react";
import { LoadingStatusModal } from "./LoadingStatusModal";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  loadingModalClosed,
  loadingReset,
  selectIsLoadingModalOpen,
  selectLoadingStages
} from "@/store/slices/loadingSlice";
import { forceReload } from "@/utils/nativeUtils/customActions";

export const LoadingStatusModalHost = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectIsLoadingModalOpen);
  const stages = useAppSelector(selectLoadingStages);

  const handleRetry = useCallback(() => {
    dispatch(loadingReset());
    forceReload();
  }, [dispatch]);
  const handleClose = useCallback(() => {
    dispatch(loadingModalClosed());
  }, [dispatch]);

  return (
    <LoadingStatusModal
      isOpen={isOpen}
      stages={stages}
      onRetry={handleRetry}
      onClose={handleClose}
    />
  );
};
